// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__o68jM","detailsBorder":"styles_detailsBorder__1dLGq"};